<div class="actions">
	<app-button
		appearance="secondary"
		size="s"
		[tuiDropdownMinHeight]="600"
		[tuiDropdownMaxHeight]="600"
		(clicked)="openInfoOption()"
	>
		@if (!isLoadingInfo()) {
			{{ 'options.actions.info' | translate }}
		} @else {
			<tui-loader
				[showLoader]="true"
				size="s"
			/>
		}
	</app-button>
	<app-button
		appearance="secondary"
		size="s"
		[isDisabled]="openedDropdown() === dropdownVariantEnum.OPTION_CREATE_ORDER"
		[tuiDropdownMinHeight]="600"
		[tuiDropdownMaxHeight]="600"
		[tuiDropdown]="createOrder"
		[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.OPTION_CREATE_ORDER"
		(clicked)="toggleDropdown(dropdownVariantEnum.OPTION_CREATE_ORDER)"
	>
		{{ 'options.actions.trade' | translate }}
	</app-button>
</div>

<ng-template #createOrder>
	<div
		appClickOutside
		[ignoreSelectors]="['.dropdown-trading-not-allowed']"
		(clickOutside)="onClickOutside()"
	>
		<app-create-order-option
			[optionContract]="option()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>
